<template>
  <div class="content-item__add">
    <div class="content-item__add-icon" @click.stop="onAdd">
      <i class="icon-plus-small"></i>
    </div>

    <Modal v-if="showContentAddAddonModal" @closeModal="onCloseModal">
      <template #modal-heading>{{ contentModalHeading }}</template>
      <template #modal-content>
        <ModalContentAddAddon :column-model="columnModel" @closeModal="showContentAddAddonModal = false" />
      </template>
    </Modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue';
import ColumnModel from '@/components/layout/column/ColumnModel';
import Modal from '@/components/components/modals/Modal.vue';
import ModalContentAddAddon from '@/components/components/editing/Modals/ModalContentAddAddon.vue';

export default defineComponent({
  name: 'LFNavigatorContentAdd',
  components: {
    ModalContentAddAddon,
    Modal
  },
  props: {
    columnModel: {
      type: Object as PropType<ColumnModel>,
      required: true
    }
  },
  emits: ['modalOpen', 'modalClose'],
  setup(props, context) {
    const showContentAddAddonModal = ref(false);
    const contentModalHeading = ref('Blocks');

    const onAdd = () => {
      showContentAddAddonModal.value = true;
      context.emit('modalOpen');
    };

    const onCloseModal = () => {
      showContentAddAddonModal.value = false;
      context.emit('modalClose');
    };

    return {
      showContentAddAddonModal,
      contentModalHeading,
      onAdd,
      onCloseModal
    };
  }
});
</script>

<style lang="scss" scoped>
.content-item__add {
  position: absolute;
  width: 25px;
  height: 25px;
  top: 100%;
  left: 50%;
  margin-left: -12px;
  padding: 0;
  z-index: 11;
}

.content-item__add-icon {
  display: block;
  margin: 0 auto;
  background: $edit-border-color;
  width: 25px;
  height: 25px;
  border-radius: 0;
  font-size: 10px;
  line-height: 26px;
  color: #fff;
  text-align: center;
  transition: background-color 125ms linear;
  cursor: pointer;

  &:hover {
    background: darken($edit-border-color, 10%);
  }
}
</style>
